<template>
  <div>
    <div
      class="column-content-container"
      :style="{
        backgroundImage: `url(${configDataForm.backgroundImageFullUrl || noUpload})`,
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center',
      }"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <a
        v-for="item in columnContentList"
        :key="item.id"
        :href="item.url ? item.url : '#'"
        class="column-content-item"
      >
        <span
          class="column-content-item-image"
          :style="{ 'background-color': item.backgroundColor }"
        >
          <img :src="item.coverImageUrl || noUpload" fit="cover" />
        </span>
        <span class="column-content-item-content">
          <span class="column-content-item-content-title">
            {{ item.title }}
          </span>
          <span class="column-content-item-content-desc">
            {{ item.digest }}
          </span>
          <span class="column-content-item-content-date">
            {{
              new Date(item.publishTime).getFullYear() +
              '-' +
              (new Date(item.publishTime).getMonth() + 1) +
              '-' +
              new Date(item.publishTime).getDate()
            }}
          </span>
        </span>
      </a>
      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <column-content-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></column-content-edit-form>
    </el-drawer>
  </div>
</template>

<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import columnContentEditForm from './ColumnContentEditFormFive.vue';

// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;

const columnContentList = ref([]);

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);
// 创建变量设默认值
const configDataForm = ref('');
if (props.componentData.configData) {
  // 直接这样写SSR服务器渲可以得到数据
  configDataForm.value = JSON.parse(props.componentData.configData);
  columnContentList.value = configDataForm.value.items[0].materialInfo;
  /**
   * 后台编辑，需要等数据更新了都
   */
  nextTick(() => {
    configDataForm.value = JSON.parse(props.componentData.configData);
    columnContentList.value = configDataForm.value.items[0].materialInfo;
  });
}
// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};

/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* PC端样式 */
@include pc {
  .column-content-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 446px;
  }

  .column-content-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 400px;
    height: 380px;
    padding: 14px;
    overflow: hidden;
    border: 1px solid var(--el-color-grey-light-9-238);
    transition: all $website-duration-normal $website-ease-out;
  }

  .column-content-item:hover {
    margin-top: -18px;
    box-shadow: $website-shadow-lg;
  }

  .column-content-item:not(:last-of-type) {
    margin-right: 24px;
  }

  .column-content-item-image {
    width: 380px;
    height: 230px;
    padding: 8px;
    box-shadow: $website-shadow-md;
    transition: 0.4s;
  }

  .column-content-item-image img {
    width: 100%;
    height: 100%;
  }

  .column-content-item-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    transition: 0.4s;
  }

  .column-content-item-content-title {
    max-width: 350px;
    margin: 10px 0 0;
    overflow: hidden;
    font-size: 16px;
    font-weight: 600;
    line-height: 40px;
    color: var(--el-color-black);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .column-content-item-content-desc {
    display: -webkit-box;
    max-width: 350px;
    height: 40px;
    margin: 0 0 15px;
    overflow: hidden;
    font-size: 16px;
    color: var(--el-color-grey-light-9);
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .column-content-item-content-date {
    display: -webkit-box;
    max-width: 350px;
    margin: 0 0 15px;
    overflow: hidden;
    font-size: 16px;
    color: var(--el-color-grey-light-9);
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

/* 移动端样式 */
@include mobile {
  .column-content-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 4vw;
    background-color: #fff;
    // background-image: none !important;
  }

  .column-content-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;
    padding: 3vw;
    margin-bottom: 3vw;
    overflow: hidden;
    border: 1px solid rgb(0 0 0 / 6%);
    border-radius: 2vw;
    transition: all $website-duration-fast $website-ease-out;

    &:active {
      border-color: $website-primary;
      transform: scale(0.98);
    }
  }

  .column-content-item-image {
    width: 100%;
    height: 40vw;
    padding: 0;
    margin-bottom: 2vw;
    border-radius: 1vw;
    box-shadow: none;
    transition: none;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 1vw;
    }
  }

  .column-content-item-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }

  .column-content-item-content-title {
    max-width: 100%;
    margin: 0 0 2vw;
    overflow: hidden;
    font-size: 4vw;
    font-weight: 600;
    line-height: 1.4;
    color: var(--el-color-black);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .column-content-item-content-desc {
    display: -webkit-box;
    max-width: 100%;
    height: auto;
    margin: 0 0 2vw;
    overflow: hidden;
    font-size: 3.5vw;
    line-height: 1.4;
    color: var(--el-color-grey-light-9);
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .column-content-item-content-date {
    font-size: 3vw;
    color: var(--el-color-grey-light-9);
  }
}
</style>
